import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=a72e65ea&scoped=true&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"
import style0 from "./resource.vue?vue&type=style&index=0&id=a72e65ea&lang=scss&scoped=true&"
import style1 from "./resource.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./resource.vue?vue&type=style&index=2&id=a72e65ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72e65ea",
  null
  
)

export default component.exports